<ng-template #alertTemplate>
  <span>{{ 'shared:error.email-service.unable_to_deliver' | i18next }}</span>
  <mbs-button [size]="MbsSize.md" [isCtrl]="true" (click)="showDetails()">{{ 'shared:buttons.seeDetails' | i18next }}</mbs-button>
</ng-template>
